import React from 'react';
import Text from 'components/Text';
import { ITableModel } from '../../interface';
import { StatusDaysToExpire } from './styles';

const labelCode = {
  label: 'Código',
  key: 'productCode',
  size: 115,
  maxSize: 115,
};

const labelProductDescription = {
  label: 'Produto',
  key: 'productDescription',
  size: 350
};

const labelCustomer = {
  label: 'Cliente',
  key: 'customerName',
  size: 350,
  maxSize: 350,
};

const labelDaysToExpire = {
  label: 'Validade',
  key: 'daysToExpire',
  size: 200,
  maxSize: 200,
  noFilter: true,
  Component: (data: any) => (
    <>
      <StatusDaysToExpire variant={data.daysToExpire} />
      <Text className="color-blue-gray first-letter-uppercase" size={12} showTip>
        {data.daysToExpireLabel}
      </Text>
    </>
  )
};

const labelUnitMeasurement = {
  label: 'Unidade',
  key: 'unitMeasurement',
  size: 150,
  maxSize: 150
};

const labelTotalBalance = {
  label: 'Estoque',
  key: 'totalBalance',
  size: 150,
  maxSize: 150,
  noFilter: true
};

const cteModel: Array<ITableModel> = [
  labelCode,
  labelProductDescription,
  labelCustomer,
  labelDaysToExpire,
  labelUnitMeasurement,
  labelTotalBalance,
];

const cteModelCompleteStockCte = () => {
  const model: Array<ITableModel> = [
    ...cteModel
  ];

  return model;
};

export {
  cteModelCompleteStockCte
};